import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserAltSlash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Select from "react-select";
import { Button, Dropdown as AntDropdown, Modal } from "antd";

import styles from "../styles/style.module.css";
import commonStyles from "../../../lib/common/common.module.css";
import { APP_ROUTES, LOCAL_CONSTANTS } from "../../../lib/constants";
import { UserTypes } from "../../../interfaces";
import { list, update, updateActivationRequestStatus } from "../api";
import Layout from "../../../ui/layout";
import { IMAGES } from "../../../assets/images";
import { DropDownMenu, ActionButton, Pagination, Popup } from "../../../ui";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import SelectColumns from "../../../ui/Popup/selectColumn";
import { getRole } from "../../../lib/common/common";
import { exportToExcelInChunks } from "../../../utils/excel.export";

const statusOptions = [
  { value: "1", label: "Pending" },
  { value: "2", label: "Success" },
  { value: "3", label: "Failed" },
  { value: "4", label: "Activate" },
];

const ActivationRequest = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // useEffect(() => {   
  //   const roles: any = window.localStorage.getItem("admin_roles")
  //   if (roles == 4 || roles == 5) return navigate(APP_ROUTES.PARTNERS);
  // },[])
  const [pagination, setPagination] = useState({
    skip: 0,
    limit: LOCAL_CONSTANTS.limitCount,
  });
  const [order, setSortOrder] = useState<number>(0);
  const [sortBy, setSortColumn] = useState<string>("");
  const [blockedAccounts, setBlockedAccounts] = useState<boolean | null>(null);
  const [verifiedEmailAccount, setVerifiedEmailAccounts] = useState<boolean | null>(null);
  const [verifiedPhoneNoAccount, setVerifiedPhoneNoAccounts] = useState<boolean | null>(null);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [show, setShow] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState<any[]>([
    ...LOCAL_CONSTANTS.ActivationRequestTableHeaders,
    { label: "Transaction Id", value: "Transaction Id" }
  ]);
  const [users, setUsers] = useState<{ list: any[]; count: number }>({
    list: [],
    count: 0,
  });


  const [loading, setLoading] = useState<boolean>(true);
  const [dialog, setDialog] = useState({ show: false, id: "", status: false });

  const [searchObject, setSearchObject] = useState<any>({});

  const [editingPhoneId, setEditingPhoneId] = useState<string | null>(null);
  const [newPhoneNumber, setNewPhoneNumber] = useState<string>("");
  const [phoneUpdating, setPhoneUpdating] = useState<string | null>(null);

  const [editingTravelId, setEditingTravelId] = useState<string | null>(null);
  const [newTravelDate, setNewTravelDate] = useState<string>("");
  const [travelUpdating, setTravelUpdating] = useState<string | null>(null);

  const [editingSimId, setEditingSimId] = useState<string | null>(null);
  const [newSimActivationDate, setNewSimActivationDate] = useState<string>("");
  const [simUpdating, setSimUpdating] = useState<string | null>(null);

  const getStatusLabel = (statusValue: string | number) => {
    const status = statusOptions.find(option => option.value === String(statusValue));
    return status ? status.label.toUpperCase() : "N/A";
  };

  const [statusUpdating, setStatusUpdating] = useState<string | null>(null);
  
  // Add state for activation popup
  const [activationPopup, setActivationPopup] = useState({
    show: false,
    requestId: "",
    activatePhoneNumber: ""
  });

  const handleStatusUpdate = async (requestId: string, newStatus: string) => {
    // If status is "Activate" (value "4"), show popup for phone number
    if (newStatus === "4") {
      setActivationPopup({
        show: true,
        requestId,
        activatePhoneNumber: ""
      });
      return;
    }
    
    // For other statuses, proceed normally
    setStatusUpdating(requestId);
    try {
      await updateActivationRequestStatus(requestId, { status: Number(newStatus) });
      // Update local state
      const updatedUsers = users.list.map(item =>
        item._id === requestId ? { ...item, status: Number(newStatus) } : item
      );
      setUsers({ ...users, list: updatedUsers });
      toast.success('Status updated successfully');
    } catch (error) {
      toast.error('Failed to update status');
    } finally {
      setStatusUpdating(null);
    }
  };

  const handleActivationSubmit = async () => {
    if (!activationPopup.activatePhoneNumber.trim()) {
      toast.error('Please enter activation phone number');
      return;
    }
    
    setStatusUpdating(activationPopup.requestId);
    try {
      await updateActivationRequestStatus(activationPopup.requestId, { 
        status: 4,
        activatePhoneNumber: activationPopup.activatePhoneNumber 
      });
      
      // Update local state
      const updatedUsers = users.list.map(item =>
        item._id === activationPopup.requestId ? { 
          ...item, 
          status: 4,
          activatePhoneNumber: activationPopup.activatePhoneNumber 
        } : item
      );
      setUsers({ ...users, list: updatedUsers });
      
      toast.success('Status updated to Activate successfully');
      setActivationPopup({ show: false, requestId: "", activatePhoneNumber: "" });
    } catch (error) {
      toast.error('Failed to update status');
    } finally {
      setStatusUpdating(null);
    }
  };

  const handleActivationCancel = () => {
    setActivationPopup({ show: false, requestId: "", activatePhoneNumber: "" });
  };

  const handleEditPhone = (id: string, currentPhone: string) => {
    setEditingPhoneId(id);
    setNewPhoneNumber(currentPhone);
  };

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewPhoneNumber(e.target.value);
  };

  const toDateInputValue = (dateStr?: string) => {
    if (!dateStr) return "";
    const m = moment(dateStr);
    if (!m.isValid()) return "";
    return m.format("YYYY-MM-DD");
  };

  const formatDisplayDate = (value?: any) => {
    if (!value) return "N/A";
    const m = moment(value, [moment.ISO_8601, "YYYY-MM-DD", "DD/MM/YYYY"], true);
    if (!m.isValid()) {
      // Try non-strict as a last resort
      const m2 = moment(value);
      return m2.isValid() ? m2.format("YYYY-MM-DD") : "N/A";
    }
    return m.format("YYYY-MM-DD");
  };

  const handleEditTravelDate = (id: string, currentDate?: string) => {
    setEditingTravelId(id);
    setNewTravelDate(toDateInputValue(currentDate));
  };

  const handleTravelDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewTravelDate(e.target.value);
  };

  const handleSaveTravelDate = async (id: string) => {
    setTravelUpdating(id);
    try {
      await updateActivationRequestStatus(id, { travelDate: newTravelDate });
      const updatedUsers = users.list.map(item =>
        item._id === id ? { ...item, travelDate: newTravelDate } : item
      );
      setUsers({ ...users, list: updatedUsers });
      toast.success('Travel date updated successfully');
      setEditingTravelId(null);
    } catch (error) {
      toast.error('Failed to update travel date');
    } finally {
      setTravelUpdating(null);
    }
  };

  const handleCancelTravelEdit = () => {
    setEditingTravelId(null);
    setNewTravelDate("");
  };

  const handleEditSimActivationDate = (id: string, currentDate?: string) => {
    setEditingSimId(id);
    setNewSimActivationDate(toDateInputValue(currentDate));
  };

  const handleSimActivationDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewSimActivationDate(e.target.value);
  };

  const handleSaveSimActivationDate = async (id: string) => {
    setSimUpdating(id);
    try {
      await updateActivationRequestStatus(id, { simActivationDate: newSimActivationDate });
      const updatedUsers = users.list.map(item =>
        item._id === id ? { ...item, simActivationDate: newSimActivationDate } : item
      );
      setUsers({ ...users, list: updatedUsers });
      toast.success('SIM activation date updated successfully');
      setEditingSimId(null);
    } catch (error) {
      toast.error('Failed to update SIM activation date');
    } finally {
      setSimUpdating(null);
    }
  };

  const handleCancelSimEdit = () => {
    setEditingSimId(null);
    setNewSimActivationDate("");
  };

  const handleSavePhone = async (id: string) => {
    setPhoneUpdating(id);
    try {
      await updateActivationRequestStatus(id, { phoneNumber: newPhoneNumber });
      // Update local state
      const updatedUsers = users.list.map(item =>
        item._id === id ? { ...item, phoneNumber: newPhoneNumber, activatePhoneNumber: newPhoneNumber } : item
      );
      setUsers({ ...users, list: updatedUsers });
      toast.success('Phone number updated successfully');
      setEditingPhoneId(null);
    } catch (error) {
      toast.error('Failed to update phone number');
    } finally {
      setPhoneUpdating(null);
    }
  };

  const handleCancelEdit = () => {
    setEditingPhoneId(null);
    setNewPhoneNumber("");
  };

  const listUsers = (
    pageIndex = pagination.skip,
    isBlocked: boolean | null = null,
    isPhoneNoVerified: boolean | null = null,
    isEmailVerified: boolean | null = null
  ) => {
    let query: any = {
      page: (1 + pageIndex),
      limit: pagination.limit,
     ...searchObject,
    };

    if (startDate) {
      query.startDate = startDate;
    }
    if (endDate) {
      query.endDate = endDate;
    }
    list(query).then(({ data }) => {
      // setUsers({ list: data.data
      //   , count: data.count });
      console.log(data,"data--------------");
      
      setUsers({ list: data.data, count: data.pagination.total });
      setLoading(false);
    });
  };
const handleSelectColumn = () => {
setShow(true);
}

const handleResetFilters = () => {
  setSearchObject({});
  setStartDate("");
  setEndDate("");
  setPagination(prev => ({...prev, skip:0}));
}

  useEffect(() => {
    setLoading(true);
    const debounceSearch = setTimeout(() => {
      listUsers();
    }, 500);
    return () => {
      clearTimeout(debounceSearch);
    };
  }, [pagination ,searchObject, startDate, endDate]);

  useEffect(() => {
    console.log(searchObject, "searchObject")
  }, [searchObject]);


  const blockUnblockUser = () => {
    const payload = {
      userId: dialog.id,
      isBlocked: dialog.status,
    };
    toast.promise(
      update(payload),
      {
        pending: {
          render() {
            return LOCAL_CONSTANTS.updatingUser;
          },
        },
        success: {
          render() {
            let tempUser = users.list;
            let index = tempUser.findIndex((item) => item._id === dialog.id);

            tempUser[index].isBlocked = !tempUser[index].isBlocked;

            setUsers({ ...users, list: tempUser });

            setDialog({ show: false, id: "", status: false });
            return dialog.status
              ? LOCAL_CONSTANTS.userBlockedSuccessfully
              : LOCAL_CONSTANTS.userUnblockedSuccessfully;
          },
        },
        error: {
          render() {
            return LOCAL_CONSTANTS.errorOnUpdatingUser;
          },
        },
      });
  };

  const handleSort = (column: string) => {
    setSortColumn(column);
    setSortOrder(
      order === LOCAL_CONSTANTS.descKey
        ? LOCAL_CONSTANTS.ascKey
        : LOCAL_CONSTANTS.descKey
    );
    const query = {
      ...pagination,
      order:
        order === LOCAL_CONSTANTS.descKey
          ? LOCAL_CONSTANTS.ascKey
          : LOCAL_CONSTANTS.descKey,
      sortBy: column,
    };
    list(query).then(({ data }) => {
      setUsers({ list: data.data
        , count: data.total });
      setLoading(false);
    });
  };

  const [exporting, setExporting] = useState<boolean>(false);

  const handleExportByDateRange = async () => {
    setExporting(true);
    try {
      // Only send whichever date(s) are actually filled — backend supports
      // startDate/endDate independently, both are not required together
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      const url = `https://api-cb.commbitz.com/zolve-admin/activation-requests/export-csv?${params.toString()}`;
      const response = await fetch(url, { method: "GET" });
      if (!response.ok) throw new Error("Failed to export CSV");
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      const fileSuffix = startDate && endDate
        ? `${startDate}_to_${endDate}`
        : startDate
        ? `from_${startDate}`
        : `till_${endDate}`;
      link.download = `activation_requests_${fileSuffix}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("CSV exported successfully");
    } catch (error) {
      toast.error("Failed to export CSV");
    } finally {
      setExporting(false);
    }
  };

  // Export current page — independent of date range, exports only the rows
  // currently loaded/visible on this page (respects active filters & selected columns)
  const getExportCellValue = (item: any, columnValue: string) => {
    switch (columnValue) {
      case "Name":
        return item.name || "N/A";
      case "Email":
        return item.email || "N/A";
      case "Eid":
        return item.eid || "N/A";
      case "Imei":
        return item.imei || "N/A";
      case "Phone Number":
        return item.phoneNumber || item.activatePhoneNumber || "N/A";
      case "Order Id":
        return item.orderDetails?.[0]?.orderId || "N/A";
      case "Order Type":
        return item.orderDetails?.[0]?.orderType || "N/A";
      case "Sim Type":
        return item.orderDetails?.[0]?.simType === 1
          ? "Physical"
          : item.orderDetails?.[0]?.simType === 2
          ? "eSim"
          : "N/A";
      case "Zip Code":
        return item?.zipCode || "N/A";
      case "Status":
        return getStatusLabel(item?.status || "1");
      case "ICCID":
        return item?.simNumber || "N/A";
      case "Plan": {
        const rawData = item.variantDetails?.data;
        const numeric =
          typeof rawData === "number"
            ? rawData
            : rawData != null && !isNaN(Number(rawData))
            ? Number(rawData)
            : null;
        if (numeric === null) return "N/A";
        return numeric === -1 ? "Unlimited" : `${numeric / 1000} GB`;
      }
      case "Price": {
        const price = item.variantDetails?.price;
        return typeof price === "number" ? price : price || "N/A";
      }
      case "Duration":
        return item.variantDetails?.duration || "N/A";
      case "Travel Date":
        return formatDisplayDate(item.travelDate || item.tarvelDate || item.orderDetails?.[0]?.travelDate);
      case "Sim Activation Date":
        return formatDisplayDate(item.simActivationDate || item.orderDetails?.[0]?.simActivationDate);
      case "Payment Date":
        return formatDisplayDate(item.paymentDate);
      case "Created Date":
        return formatDisplayDate(item.createdAt);
      case "Stripe Customer ID":
        return item?.stripeCustomerId || "N/A";
      case "Activate Phone Number":
        return item?.activatePhoneNumber || "N/A";
      case "Transaction Id":
        return item?.paymentIntent || "N/A";
      default:
        return "N/A";
    }
  };

  const handleExportCurrentPage = () => {
    if (!users.list || users.list.length === 0) {
      toast.error("No records on this page to export");
      return;
    }
    const exportColumns = selectedColumns.filter((col) => col.label !== "Actions" && col.label !== "Action");
    const customHeader = exportColumns.map((col) => col.label);
    const getData = users.list.map((item) => {
      const row: Record<string, any> = {};
      exportColumns.forEach((col) => {
        row[col.value] = getExportCellValue(item, col.value);
      });
      return row;
    });
    exportToExcelInChunks(getData, `activation_requests_page_${pagination.skip + 1}`, 300, customHeader);
    toast.success("Current page exported successfully");
  };

  // Single export entry point:
  // - If either Start Date or End Date is filled -> export via date API (server-side CSV,
  //   backend supports startDate/endDate independently, both are not required together)
  // - If neither date is filled -> export just the currently open/loaded page (client-side)
  const handleExport = () => {
    if (startDate || endDate) {
      handleExportByDateRange();
    } else {
      handleExportCurrentPage();
    }
  };

  return (
    <Layout title="Activation Request">
      <div className={commonStyles.tableData}>
        <div className={commonStyles.topFilter}>
          <div
            className="d-flex align-items-center flex-wrap"
            style={{ gap: "14px", rowGap: "12px" }}
          >
            <div style={{ width: "200px" }}>
              <Select
                options={statusOptions}
                onChange={(option: any) => {
                  setSearchObject((prev:any) => ({ ...prev, status: option?.value || "" }));
                }}
                value={statusOptions.find((o) => o.value === searchObject.status) || null}
                placeholder="Filter by status"
                isSearchable={false}
                isClearable
                className="w-100"
                styles={{
                  control: (base) => ({ ...base, minHeight: 40, height: 40, borderRadius: 4 }),
                  valueContainer: (base) => ({ ...base, height: 40, padding: "0 8px" }),
                  indicatorsContainer: (base) => ({ ...base, height: 40 }),
                }}
              />
            </div>
            <input
              type="date"
              value={startDate}
              onChange={e => setStartDate(e.target.value)}
              onClick={(e) => { try { (e.currentTarget as HTMLInputElement).showPicker?.(); } catch {} }}
              min="2000-01-01"
              max="2099-12-31"
              style={{
                height: 40,
                width: 170,
                minWidth: 170,
                padding: "0 10px",
                borderRadius: 4,
                border: "1px solid #333",
                boxSizing: "border-box",
                fontSize: 14,
                lineHeight: "40px",
                colorScheme: "light",
                cursor: "pointer",
              }}
              placeholder="Start Date"
            />
            <input
              type="date"
              value={endDate}
              onChange={e => {
                if (startDate && e.target.value < startDate) {
                  toast.error("End date cannot be before start date");
                  return;
                }
                setEndDate(e.target.value);
              }}
              onClick={(e) => { try { (e.currentTarget as HTMLInputElement).showPicker?.(); } catch {} }}
              min="2000-01-01"
              max="2099-12-31"
              style={{
                height: 40,
                width: 170,
                minWidth: 170,
                padding: "0 10px",
                borderRadius: 4,
                border: "1px solid #333",
                boxSizing: "border-box",
                fontSize: 14,
                lineHeight: "40px",
                colorScheme: "light",
              }}
              placeholder="End Date"
            />
            <button
              onClick={handleExport}
              disabled={exporting}
              title={startDate && endDate ? "Exports records within the selected date range" : "Exports the currently open page"}
              style={{
                height: 40,
                background: "#00ff99",
                color: "#000",
                border: "none",
                borderRadius: 4,
                padding: "0 18px",
                fontWeight: 600,
                cursor: exporting ? "not-allowed" : "pointer",
                opacity: exporting ? 0.5 : 1
              }}
            >
              {exporting ? "Exporting..." : "Export to CSV"}
            </button>
            <button
              onClick={handleResetFilters}
              className={styles.loyalityPointBtn}
              style={{ height: 40, padding: "0 28px" }}
            >
              Reset
            </button>
          </div>
        </div>


        <div className={commonStyles.topFilter}>
          <div className={`d-flex gap-3 align-items-center w-100 ${styles.filterSlect}`}>
            {/* <button
            onClick={handleSelectColumn}
            className={`mt-4 ${styles.loyalityPointBtn}`}
          >
           Select Columns
          </button> */}
        
          </div>
        </div>
        <div className={styles.scrollTable}>
          <table>
            <thead>
              <tr>
                {selectedColumns?.map((header: UserTypes.TableHeader) => (
                  selectedColumns.includes(header)&&<th
                    className={`${["fullName", "phoneNumber"].includes(header?.value)
                      ? "cursor-pointer"
                      : ""
                      }`}
                    onClick={() => {
                      if (["fullName", "phoneNumber"].includes(header?.value)) {
                        handleSort(header?.value);
                      }
                    }}
                    key={header?.value}
                  >
                    {header?.label}
                    {/* {sortBy === header?.value &&
                      ["fullName", "phoneNumber"].includes(header?.value) &&
                      renderSortIcon(header?.value)} */}
                      <div className={commonStyles.topFilter}>
                      <div className={styles.date_calender}>
         { header.label!=="Actions" &&!header.label.includes("Date")&&header.label!=="Role"&&header.label!=="Blocked"&&<input
            value={searchObject[header.value] || ''}
            onChange={(e) => {
              setSearchObject({ ...searchObject, [header.value]: e.target.value });
            }}
            
       
          />}
         
          </div>
          { header.label==="Role"&& <div className="w-100">
             
              <Select
                options={LOCAL_CONSTANTS.ZOLVE_ROLES}
                onChange={(response) => {
                  if (response) {
                    setSearchObject({ ...searchObject, [header.value]: response.value });
                  } else {
                    const newSearchObject = {...searchObject};
                    delete newSearchObject[header.value];
                    setSearchObject(newSearchObject);
                  }
                }}
                value={LOCAL_CONSTANTS.ZOLVE_ROLES.find((o:any) => o.value === searchObject[header.value]) || null}
                placeholder="Select Role"
                isClearable
                className="w-100"
              />
              </div>}
              { header.label==="Blocked"&& <div className="w-100">
             
             <Select
               options={LOCAL_CONSTANTS.blockedAccounts}
               onChange={(response) => {
                if (response) {
                  setSearchObject({ ...searchObject, [header.value]: response.value });
                } else {
                  const newSearchObject = {...searchObject};
                  delete newSearchObject[header.value];
                  setSearchObject(newSearchObject);
                }
               }}
               value={LOCAL_CONSTANTS.blockedAccounts.find((o:any) => o.value === searchObject[header.value]) || null}
               placeholder="Select Status"
               isClearable
               className="w-100"
             />
             </div>}

                      </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan={17} align="center" className={styles.loadingText}>
                    {LOCAL_CONSTANTS.loading}
                  </td>
                </tr>
              )}
              {!loading && users.list?.length === 0 && (
                <tr>
                  <td colSpan={17} align="center">
                    No User Found
                  </td>
                </tr>
              )}
              {!loading &&
                users.list.map((item) => (
                  <tr>{selectedColumns.map((rr)=>{
                   
                   if (rr.value === "Action") {
  return <td>{"N/A"}</td>;
} else if (rr.value === "Name") {
  return <td>{item.name||"N/A"}</td>
} else if (rr.value === "Email") {
  return <td>{item.email||"N/A"}</td>;
  

} else if (rr.value === "Eid") {
  return <td>{item.eid||"N/A"}</td>;
} 
else if (rr.value === "Imei") {
    return <td>{item.imei||"N/A"}</td>;
}
else if (rr.value === "Phone Number") {
  if (editingPhoneId === item._id) {
    return (
      <td>
        <input
          type="text"
          value={newPhoneNumber}
          onChange={handlePhoneNumberChange}
          disabled={phoneUpdating === item._id}
          style={{ width: "120px" }}
        />
        <button
          onClick={() => handleSavePhone(item._id)}
          disabled={phoneUpdating === item._id}
          style={{ marginLeft: "4px" }}
        >
          
          {phoneUpdating === item._id ? "Saving..." : "Save"}
        </button>
        <button onClick={handleCancelEdit} disabled={phoneUpdating === item._id} style={{ marginLeft: "4px" }}>
          Cancel
        </button>
      </td>
    );
  } else {
    return (
      <td>
        {item.phoneNumber || item.activatePhoneNumber || "N/A"}
        <button
          onClick={() => handleEditPhone(item._id, item.phoneNumber || item.activatePhoneNumber || "")}
          style={{ marginLeft: "8px" }}
        >
          Edit
        </button>
      </td>
    );
  }
} else if (rr.value === "Order Id") {
  return <td>{item.orderDetails[0]?.orderId || "N/A"}</td>;
} 
else if (rr.value === "Order Type") {
    return <td>{item.orderDetails[0]?.orderType||"N/A"}</td>;
}
else if (rr.value === "Sim Type") {
  return   <td>
      {item.orderDetails[0]?.simType === 1
        ? "Physical"
        : item.orderDetails[0]?.simType === 2
        ? "eSim"
        : "N/A"}
    </td>;
} else if (rr.value === "Zip Code") {
  return  <td>{item?.zipCode||"N/A"} </td>;
} else if (rr.value === "Status") {
  const currentStatus = item?.status || "1"; // Default to Pending if no status
  const statusLabel = getStatusLabel(currentStatus);
  return (
    <td>
      <AntDropdown
        menu={{
          items: statusOptions.map(option => ({
            key: option.value,
            label: option.label,
            onClick: () => handleStatusUpdate(item._id, option.value),
            disabled: statusUpdating === item._id
          }))
        }}
        trigger={['click']}
        disabled={statusUpdating === item._id}
      >
        <div
          style={{
            cursor: 'pointer',
            padding: '4px 8px',
            borderRadius: '4px',
            backgroundColor: statusUpdating === item._id ? '#f5f5f5' : '#f0f0f0',
            border: '1px solid #d9d9d9',
            display: 'inline-block',
            minWidth: '80px',
            textAlign: 'center'
          }}
        >
          {statusUpdating === item._id ? (
            <span>Updating...</span>
          ) : (
            <span style={{ color: 'black' }}>{statusLabel}</span>
          )}
        </div>
      </AntDropdown>
    </td>
  );
}  else if (rr.value === "ICCID") {
  return  <td>{item?.simNumber||"N/A"} </td>;
} else if (rr.value === "Plan") {
  const rawData = item.variantDetails?.data;
  let display = "N/A";
  const numeric = typeof rawData === 'number' ? rawData : (rawData != null && !isNaN(Number(rawData)) ? Number(rawData) : null);
  if (numeric !== null) {
    if (numeric === -1) display = "Unlimited";
    else display = `${numeric / 1000} GB`;
  }
  return <td>{display}</td>;
} else if (rr.value === "Price") {
  const price = item.variantDetails?.price;
  return <td>{typeof price === 'number' ? price : (price || "N/A")}</td>;
} else if (rr.value === "Duration") {
  const duration = item.variantDetails?.duration;
  return <td>{duration || "N/A"}</td>;
} else if (rr.value === "Travel Date") {
  if (editingTravelId === item._id) {
    return (
      <td>
        <input
          type="date"
          value={newTravelDate}
          onChange={handleTravelDateChange}
          disabled={travelUpdating === item._id}
          style={{ width: "150px" }}
        />
        <button
          onClick={() => handleSaveTravelDate(item._id)}
          disabled={travelUpdating === item._id}
          style={{ marginLeft: "4px" }}
        >
          {travelUpdating === item._id ? "Saving..." : "Save"}
        </button>
        <button onClick={handleCancelTravelEdit} disabled={travelUpdating === item._id} style={{ marginLeft: "4px" }}>
          Cancel
        </button>
      </td>
    );
  } else {
    return (
      <td>
        {formatDisplayDate(item.travelDate || item.tarvelDate || item.orderDetails?.[0]?.travelDate)}
        <button
          onClick={() => handleEditTravelDate(item._id, (item.travelDate || item.tarvelDate || item.orderDetails?.[0]?.travelDate))}
          style={{ marginLeft: "8px" }}
        >
          Edit
        </button>
      </td>
    );
  }
} else if (rr.value === "Sim Activation Date") {
  if (editingSimId === item._id) {
    return (
      <td>
        <input
          type="date"
          value={newSimActivationDate}
          onChange={handleSimActivationDateChange}
          disabled={simUpdating === item._id}
          style={{ width: "150px" }}
        />
        <button
          onClick={() => handleSaveSimActivationDate(item._id)}
          disabled={simUpdating === item._id}
          style={{ marginLeft: "4px" }}
        >
          {simUpdating === item._id ? "Saving..." : "Save"}
        </button>
        <button onClick={handleCancelSimEdit} disabled={simUpdating === item._id} style={{ marginLeft: "4px" }}>
          Cancel
        </button>
      </td>
    );
  } else {
    return (
      <td>
        {formatDisplayDate(item.simActivationDate || item.orderDetails?.[0]?.simActivationDate)}
        <button
          onClick={() => handleEditSimActivationDate(item._id, (item.simActivationDate || item.orderDetails?.[0]?.simActivationDate))}
          style={{ marginLeft: "8px" }}
        >
          Edit
        </button>
      </td>
    );
  }
} else if (rr.value === "Payment Date") {
  // Try multiple possible sources for payment date
  const paymentDate = item.paymentDate || 'N/A'

  return <td>{formatDisplayDate(paymentDate)}</td>;
} else if (rr.value === "Created Date") {
  return <td>{formatDisplayDate(item.createdAt)}</td>;
} else if (rr.value === "Stripe Customer ID") {
  return <td>{item?.stripeCustomerId || "N/A"}</td>;
} else if (rr.value === "Activate Phone Number") {
  return <td>{item?.activatePhoneNumber || "N/A"}</td>;
} else if (rr.value === "Transaction Id") {
  return <td>{item?.paymentIntent || "N/A"}</td>;
}
else{
    return <td>{"N/A"}</td>;

}
                   
                   })}</tr>))}
                  
                 
                
            </tbody>
          </table>
        </div>
        <Pagination
          paginationState={pagination}
          setPaginationState={setPagination}
          count={users.count}
        />
        <Popup
          show={dialog.show}
          handleClose={() => setDialog({ show: false, id: "", status: false })}
          heading={LOCAL_CONSTANTS.areYouSure}
          content={LOCAL_CONSTANTS.areYouSureRestrictUserAccess}
          handleSubmit={blockUnblockUser}
          id={dialog.id}
        />
        
        {/* Activation Phone Number Popup */}
        <Modal 
          open={activationPopup.show} 
          onCancel={handleActivationCancel}
          title="Activate Request"
          footer={[
            <button
              key="cancel"
              type="button"
              onClick={handleActivationCancel}
              style={{
                padding: "8px 16px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                background: "#fff",
                cursor: "pointer"
              }}
            >
              Cancel
            </button>,
            <button
              key="activate"
              type="button"
              onClick={handleActivationSubmit}
              disabled={statusUpdating === activationPopup.requestId}
              style={{
                padding: "8px 16px",
                border: "none",
                borderRadius: "4px",
                background: "#007bff",
                color: "#fff",
                cursor: statusUpdating === activationPopup.requestId ? "not-allowed" : "pointer",
                opacity: statusUpdating === activationPopup.requestId ? 0.6 : 1
              }}
            >
              {statusUpdating === activationPopup.requestId ? "Updating..." : "Activate"}
            </button>
          ]}
        >
          <div style={{ marginBottom: "15px" }}>
            <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>
              Activation Phone Number:
            </label>
            <input
              type="text"
              value={activationPopup.activatePhoneNumber}
              onChange={(e) => setActivationPopup(prev => ({ ...prev, activatePhoneNumber: e.target.value }))}
              placeholder="Enter activation phone number"
              style={{
                width: "100%",
                padding: "8px 12px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                fontSize: "14px"
              }}
            />
          </div>
        </Modal>
        
        {/* <SelectColumns selectedColumns={selectedColumns} setSelectedColumns={setSelectedColumns} show={show} handleClose={()=>setShow(false)} iso="" columns={LOCAL_CONSTANTS.CustomersTableHeaders} /> */}
 
      </div>
    </Layout>
  );
};

export default ActivationRequest;
